import { colors } from "src/theme/colors";
import { theme } from "src/theme/theme";
import { typography } from "src/utils/styledComponents/typography";
import styled from "styled-components/macro";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  position: relative;
`;

/* The page's own header names this screen now; a second centred serif accent
   heading inside the card said the same thing again in another typeface. */
export const Title = styled.h2`
  display: none;
`;

/* A bounded measure rather than a percentage of the card: at 50% the form
   was a 290px ribbon in the middle of a wide white card, with fields
   narrower than their own labels. */
export const Wrapper = styled.div<{
  leanWrapper?: boolean;
  /** In a dialog the form takes the dialog's own measure. */
  $full?: boolean;
}>`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: ${({ $full }) => ($full ? "none" : "560px")};
`;
